import { render, staticRenderFns } from "./GTeachers.vue?vue&type=template&id=0b9fa1fa&scoped=true&"
import script from "./GTeachers.vue?vue&type=script&lang=ts&"
export * from "./GTeachers.vue?vue&type=script&lang=ts&"
import style0 from "./GTeachers.vue?vue&type=style&index=0&id=0b9fa1fa&lang=scss&scoped=true&"
import style1 from "./GTeachers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9fa1fa",
  null
  
)

export default component.exports